/**
 * Разбор/склейка ISO datetime для DateTimeField. Вынесено из компонента, чтобы (а) не ломать
 * react-refresh правило «один файл — только компоненты», (б) тестировать отдельно от рендера.
 */

export const splitIso = (iso: unknown, withSeconds: boolean): { date: string | null; time: string } => {
    // Защищаемся от не-string (Date / number / undefined). Mantine TimePicker
    // делает .split(':') внутри и крашится на чём угодно кроме string.
    if (typeof iso !== 'string' || !iso) return { date: null, time: withSeconds ? '00:00:00' : '00:00' };
    const [d, tRaw] = iso.split('T');
    const t = (tRaw ?? '').slice(0, withSeconds ? 8 : 5);
    return { date: d || null, time: t || (withSeconds ? '00:00:00' : '00:00') };
};

export const combine = (date: string | null, time: string, withSeconds: boolean): string | null => {
    if (!date) return null;
    // Очистка любой из частей DateTime → null (а не «осталась полночь»).
    // Mantine TimePicker по clear-кнопке зовёт onChange('') — без этой проверки
    // существующее значение тихо превратилось бы в YYYY-MM-DDT00:00.
    if (!time) return null;
    const t = (time.length >= 5 ? time : withSeconds ? '00:00:00' : '00:00').slice(0, withSeconds ? 8 : 5);
    return `${date}T${t}`;
};
